module.exports = __webpack_public_path__ + "static/media/map-location.00e6ddd5.svg";